export { default } from './CatalogImage'
